/**
 * @flow
 * @relayHash 3627b65e2b599fcb472fb75f8ee132d0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DescriptionIssueTable_project$ref = any;
export type onpage_OnPageCategory_DescriptionIssueTable_QueryVariables = {|
  host: string
|};
export type onpage_OnPageCategory_DescriptionIssueTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: DescriptionIssueTable_project$ref
  |}
|};
export type onpage_OnPageCategory_DescriptionIssueTable_Query = {|
  variables: onpage_OnPageCategory_DescriptionIssueTable_QueryVariables,
  response: onpage_OnPageCategory_DescriptionIssueTable_QueryResponse,
|};
*/


/*
query onpage_OnPageCategory_DescriptionIssueTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...DescriptionIssueTable_project
    id
  }
}

fragment DescriptionIssueTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesDescriptionIssues(description: {operator: AND, values: []}, url: {operator: AND, values: []}) {
          type
          severity
          count
        }
        descriptionIssues(offset: 0, limit: 20, typeFilters: [], url: {operator: AND, values: []}, lenOrder: 0, description: {operator: AND, values: []}) {
          count
          edges {
            node {
              ...DescriptionIssueRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment DescriptionIssueRow_issue on DescriptionIssue {
  id
  severity
  description
  description_len_chr
  description_len_px
  type
  urls
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v4 = {
  "kind": "Literal",
  "name": "description",
  "value": v3,
  "type": "TextFilters"
},
v5 = {
  "kind": "Literal",
  "name": "url",
  "value": v3,
  "type": "TextFilters"
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "onpage_OnPageCategory_DescriptionIssueTable_Query",
  "id": null,
  "text": "query onpage_OnPageCategory_DescriptionIssueTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...DescriptionIssueTable_project\n    id\n  }\n}\n\nfragment DescriptionIssueTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesDescriptionIssues(description: {operator: AND, values: []}, url: {operator: AND, values: []}) {\n          type\n          severity\n          count\n        }\n        descriptionIssues(offset: 0, limit: 20, typeFilters: [], url: {operator: AND, values: []}, lenOrder: 0, description: {operator: AND, values: []}) {\n          count\n          edges {\n            node {\n              ...DescriptionIssueRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment DescriptionIssueRow_issue on DescriptionIssue {\n  id\n  severity\n  description\n  description_len_chr\n  description_len_px\n  type\n  urls\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "onpage_OnPageCategory_DescriptionIssueTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DescriptionIssueTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "onpage_OnPageCategory_DescriptionIssueTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesDescriptionIssues",
                        "storageKey": "countTypesDescriptionIssues(description:{\"operator\":\"AND\",\"values\":[]},url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v4,
                          v5
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v6,
                          v7,
                          v8
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "descriptionIssues",
                        "storageKey": "descriptionIssues(description:{\"operator\":\"AND\",\"values\":[]},lenOrder:0,limit:20,offset:0,typeFilters:[],url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v4,
                          {
                            "kind": "Literal",
                            "name": "lenOrder",
                            "value": 0,
                            "type": "Int"
                          },
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v2,
                          {
                            "kind": "Literal",
                            "name": "typeFilters",
                            "value": [],
                            "type": "[String]"
                          },
                          v5
                        ],
                        "concreteType": "DescriptionIssuesConnection",
                        "plural": false,
                        "selections": [
                          v8,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DescriptionIssuesEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "DescriptionIssue",
                                "plural": false,
                                "selections": [
                                  v9,
                                  v7,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "description",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "description_len_chr",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "description_len_px",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v6,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "urls",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v9
                    ]
                  }
                ]
              }
            ]
          },
          v9
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '00cee4679a5a15a552d0f6543a4788a7';
module.exports = node;
